import request from '@/utils/request'


// 查询动态分类列表
export function listCategory(query) {
  return request({
    url: '/dynamic/category/list',
    method: 'get',
    params: query
  })
}

// 查询动态分类分页
export function pageCategory(query) {
  return request({
    url: '/dynamic/category/page',
    method: 'get',
    params: query
  })
}

// 查询动态分类详细
export function getCategory(data) {
  return request({
    url: '/dynamic/category/detail',
    method: 'get',
    params: data
  })
}

// 新增动态分类
export function addCategory(data) {
  return request({
    url: '/dynamic/category/add',
    method: 'post',
    data: data
  })
}

// 修改动态分类
export function updateCategory(data) {
  return request({
    url: '/dynamic/category/edit',
    method: 'post',
    data: data
  })
}
// 删除动态分类
export function delCategory(data) {
  return request({
    url: '/dynamic/category/delete',
    method: 'post',
    data: data
  })
}
